var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link_gift_desBox"},[_c('header',[_vm._v(_vm._s(_vm.$t('guanxi_gift_rule_title')))]),_c('p',[_vm._v("1. "+_vm._s(_vm.$t('guanxi_gift_rule_1')))]),_c('p',[_vm._v("2. "+_vm._s(_vm.$t('guanxi_gift_rule_2')))]),_c('p',[_vm._v("3. "+_vm._s(_vm.$t('guanxi_gift_rule_3')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }